import React from "react";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../../AdminRoutes";
import { MuxSpecificationListingProvider } from "../context/MuxSpecificationListingProvider";
import { MuxSpecificationListing } from "./MuxSpecificationListing";

export const MuxSpecificationListingPage: React.VFC = () => {
    return (
        <MuxSpecificationListingProvider>
            <PageHeader>
                <HeaderBreadcrumb routes={adminRoutes} />
            </PageHeader>
            <MuxSpecificationListing />
        </MuxSpecificationListingProvider>
    );
};
